<template>
    <a-dropdown style="cursor: pointer;">
    <div>
      <img src="/static/homeIcon/user.png" alt="" />
      <span class="user-name">{{nickName}}</span>
      <a-icon type="caret-down" />
    </div>
    <a-menu slot="overlay" @click="handleMenuClick">
      <!-- <a-menu-item v-for="item in dropDownMenu" :key="item.path">
        <span v-if="item.isShow">{{item.name}}</span>
      </a-menu-item> -->
      <template v-for="item in dropDownMenu">
        <a-menu-item :key="item.path" v-if="item.isShow">
          <span>{{item.name}}</span>
        </a-menu-item>
      </template>
    </a-menu>
  </a-dropdown>
</template>

<script>
import {is_cloneDeep} from '@/utils/cloneDeep.js'
import {dropDownMenu} from './configs/config'
import { mapState } from 'vuex'
import {clearStorage, getStorage} from '@/utils'
import {signOut} from '@/api/user.js'
import {loginOut} from './configs/config'
export default {
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    nickName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dropDownMenu: []
    }
  },
  computed:{
    ...mapState({
      huashi: state => state.user.huashi
    })
  },
  watch: {
    menuList: {
      handler() {
        let Menu = is_cloneDeep(dropDownMenu)
        this.menuList.forEach(item => {
          if (item.code === 'system') {
            Menu[1].isShow = item.status === '0' ? true : false
          }
        })
        this.dropDownMenu = Menu
      }
    }
  },
   methods: {
    async handleMenuClick(e) {
      //console.log(this.huashi)
      if(e.key === '/index') {
        await signOut()
        if (!this.huashi) { //是否是华师平台登录, 不是则跳转到后台登录界面
          this.clear()
          this.$router.replace('/login')
          this.firstLogin() //重新游客登录
        } else {
          this.clear()
          window.location.href=`${loginOut}`
        }
      } else {
        this.$router.push(e.key)
      }
    },
    clear() {
      this.$store.dispatch('user/clearAccountInfo')
      clearStorage()
    },
    async firstLogin() {
      let token = getStorage("token", 0);
      if (!token || token === "") {
        let form = {
          username: "visitor@qq.com",
          password: "123456",
        };
        await this.$store.dispatch("user/LoginForm", form);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.user-name {
  margin: 5px;
}
</style>